import { Terminal, Shield, Code, Mail, Rocket, Users, Database } from 'lucide-react';

export const NAV_LINKS = [
  { path: '/', label: 'Home', icon: Terminal },
  { path: '/about', label: 'About', icon: Shield },
  { path: '/projects', label: 'Projects', icon: Code },
  { path: '/contact', label: 'Contact', icon: Mail }
];

export const SKILLS = [
  { 
    name: 'Pre-Sales Excellence', 
    icon: Rocket,
    technologies: ['POV Design & Execution', '90%+ Win Rate', 'RFP/RFI Leadership', 'MEDDIC Methodology'],
    color: 'from-green-500 to-green-700'
  },
  { 
    name: 'Security Solutions', 
    icon: Shield, 
    technologies: ['XDR/NDR/EDR', 'SIEM Integration', 'SOAR Workflows', 'Cloud Security'],
    color: 'from-blue-500 to-blue-700'
  },
  { 
    name: 'Customer Success', 
    icon: Users,
    technologies: ['C-Level Engagement', 'Technical Workshops', 'Solution Architecture', 'QBR Leadership'],
    color: 'from-purple-500 to-purple-700'
  },
  { 
    name: 'Technical Expertise', 
    icon: Terminal, 
    technologies: ['AWS/Azure/GCP', 'Network Architecture', 'OSCP/CRTO Certified', 'Detection Engineering'],
    color: 'from-red-500 to-red-700'
  }
];

export const PROJECTS = [
  {
    title: "Vectra Health Check Utility",
    description: "A comprehensive Python utility for monitoring and reporting on Vectra cybersecurity platform health status. This tool provides detailed insights into system performance, integrations, and operational status through the Vectra API.",
    tech: ["Python", "Vectra API", "Health Monitoring", "System Analytics"],
    github: "https://github.com/tobiasharms-sec/Vectra-health-check",
    demo: "https://github.com/tobiasharms-sec/Vectra-health-check#readme",
    icon: Shield,
    status: "ACTIVE",
    type: "MONITORING TOOL",
    version: "v2.0",
    impact: "Real-time Insights"
  },
  {
    title: "Vectra Active Hosts Exporter",
    description: "Python script for retrieving and exporting active hosts from Vectra RUX Platform via API v3.4 with OAuth2 authentication and CSV export functionality. Streamlines host data extraction for security analysis and reporting.",
    tech: ["Python", "Vectra API v3.4", "OAuth2", "CSV Export"],
    github: "https://github.com/tobiasharms-sec/Vectra-active-hosts",
    demo: "https://github.com/tobiasharms-sec/Vectra-active-hosts#readme",
    icon: Database,
    status: "PRODUCTION",
    type: "DATA EXPORT TOOL",
    version: "v1.5",
    impact: "Automated Reporting"
  },
  {
    title: "Cybersecurity Portfolio Website",
    description: "Modern cybersecurity-focused portfolio website built with React and Tailwind CSS. Features containerized deployment with Docker, AWS hosting, and automated CI/CD pipeline for continuous deployment.",
    tech: ["React", "Tailwind CSS", "Docker", "AWS", "GitHub Actions"],
    github: "https://github.com/tobiasharms-sec/portfolio",
    demo: "https://tobiasharms.com",
    icon: Code,
    status: "ACTIVE",
    type: "WEB APPLICATION",
    version: "v1.0",
    impact: "Professional Presence"
  }
];

export const CERTIFICATIONS = [
  { title: 'OSCP - Offensive Security Certified Professional', org: 'Offensive Security', year: '2023', color: 'red' },
  { title: 'CRTO - Certified Red Team Operator', org: 'Zero-Point Security', year: '2024', color: 'red' },
  { title: 'Master of Science - Information Systems', org: 'NOVA IMS & University of Ljubljana', year: '2018', color: 'blue' },
  { title: 'Bachelor of Science - Business Informatics', org: 'Dresden University', year: '2016', color: 'green' }
];

export const CONTACT_INFO = [
  { icon: Mail, text: 'harms.tobias89@gmail.com', href: 'mailto:harms.tobias89@gmail.com' },
  { icon: Shield, text: 'github.com/tobiasharms-sec', href: 'https://github.com/tobiasharms-sec' },
  { icon: Users, text: 'linkedin.com/in/tobiasharms', href: 'https://linkedin.com/in/tobiasharms' }
];